import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardTitle from "./CardTitle";
import { numberSx, tokens } from "../../theme";
import { updateRanges } from "../../reducer/LaserDataSlice";

/** One tile of the mockup's .metric-grid: small uppercase label above, bold value below. */
const Metric = ({ label, value, valueSx }) => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <Typography sx={{
            fontSize: "10.5px", color: tokens.muted, textTransform: "uppercase", letterSpacing: "0.04em",
        }}>
            {label}
        </Typography>
        <Typography sx={{ fontSize: "15px", fontWeight: 600, ...numberSx, ...valueSx }}>
            {value}
        </Typography>
    </Box>
);

export default function PositionCard(props) {
    const calcSettings = useSelector(state => state.calcSettings);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("position card - useEffect");
        dispatch(updateRanges({info: calcSettings.changes.info}));
    }, [calcSettings.changes.info]);

    const hasChanged = (current, changes, startName, stopName) => {
        return (current[startName] !== changes[startName]) || (current[stopName] !== changes[stopName]);
    }

    // theme.js's own note: no blue anywhere in the mockup's palette - tokens.warn (amber) is the
    // app's existing "take note" colour, already mapped to MUI's warning semantic.
    const changedSx = { color: tokens.warn };

    const rangeText = (start, stop, motorRight) => {
        let mm = (v) => Math.floor(v / 1000);
        return motorRight ? `${mm(start)}–${mm(stop)} mm` : `${mm(stop)}–${mm(start)} mm`;
    }

    const info = calcSettings.changes.info;
    console.log("PositionCard - info: ", info);

    return(
        <Card variant="outlined">
            <CardContent>
                <CardTitle title="Positions"/>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>
                    <Metric
                        label="Machine"
                        value={rangeText(info.machineStart, info.machineStop, info.motorRight)}
                        valueSx={hasChanged(calcSettings.current.info, info, "machineStart", "machineStop") ? changedSx : {}}
                    />
                    <Metric
                        label="Motor"
                        value={rangeText(info.motorStart, info.motorStop, info.motorRight)}
                        valueSx={hasChanged(calcSettings.current.info, info, "motorStart", "motorStop") ? changedSx : {}}
                    />
                    <Metric label="Distance to front foot" value={`${info.distanceToFF / 1000} mm`} />
                    <Metric label="Front foot to rear foot" value={`${info.distanceFtoR / 1000} mm`} />
                </Box>
                <Box sx={{ mt: "6px" }}>
                    <Metric label="Motor position" value={info.motorRight ? "Right" : "Left"} />
                </Box>
            </CardContent>
        </Card>
    )
}
